/****************************************************************************************
 * File Name    : FilterWorkSheet.vue
 * Function     : 필터 일일 작업일지 - 일지작성
 * Author       : 
 * Description  : 일일 작업일지 작성 및 관리
 * Modification Log
 * ======================================================================================
 * Ver  Date        	Author     	Modification
 * ======================================================================================
   1.0  2026.02.17  	        	Create
****************************************************************************************/
<template>
    <div>
        <a-row :gutter="16">
            <a-col class="gutter-row" :span="12">
                <div class="gutter-box">
                    <PageHeader title="필터 일일 작업일지 - 일지작성" />
                </div>
            </a-col>
            <a-col class="gutter-row" :span="12">
                <div class="gutter-box div_action">
                    <a-select :key="templateList.length" v-model="selectedTemplate" placeholder="템플릿 선택" style="width: 200px; margin-right: 10px;">
                        <a-select-option v-for="template in templateList" :key="template.id" :value="template.id">
                            {{ template.name }}
                        </a-select-option>
                    </a-select>
                    <span class='icon_button' @click="loadTemplate()">
                        <a-tag color="#2980B9" style="cursor:pointer;">
                            <a-icon type="plus-circle" /> 불러오기
                        </a-tag>
                    </span>
                </div>
            </a-col>
        </a-row>
        <a-divider type='horizontal' />
        
        <a-space align="end">
            <a-statistic title="작성중" :value="workingCount" style="margin-right: 50px">
                <template #prefix>
                    <a-icon type="question-circle" />
                </template>
            </a-statistic>
            <a-statistic title="작성완료" :value="completedCount" style="margin-right: 50px">
                <template #prefix>
                    <a-icon type="exclamation-circle" />
                </template>
            </a-statistic>
        </a-space>
        <p/>
        
        <!-- 작성중 목록 -->
        <a-table :columns="columns" size="small" :bordered="false" :data-source="workingData" :scroll="{ x: 0, y: '37vh' }">
            <span slot="tags" slot-scope="tags">
                <a-tag v-for="tag in tags" :key="tag" class="state-btn" :class="{ red: (tag === '작성중'), green: (tag === '작성완료') }">
                    {{ tag.toUpperCase() }}
                </a-tag>
            </span>
            <span slot="action" slot-scope="record">
                <span style='cursor:pointer' @click="handlerToEdit(record.key)"><a-icon type="edit" /> Edit</span>
                <a-divider type="vertical" />
                <span style='cursor:pointer' @click="handlerToDelete(record.key)"><a-icon type="delete" /> Delete</span>
            </span>
        </a-table>
        <p/>
        
        <!-- 작성완료 목록 -->
        <a-form class="" layout="vertical">
            <a-card>
                <a-space align="end">
                    일일 작업일지 조회
                    <a-input default-value="" v-model="filterCS">
                        <a-select slot="addonAfter" default-value="라인명" v-model="filterField">
                            <a-select-option value="라인명">라인명</a-select-option>
                            <a-select-option value="생산모델">생산모델</a-select-option>
                            <a-select-option value="작성자">작성자</a-select-option>
                        </a-select>
                    </a-input>
                    일자 조회
                    <date-picker v-model="filterDateStartCS" valueType="format" style="width:120px;"></date-picker> ~
                    <date-picker v-model="filterDateEndCS" valueType="format" style="width:120px;"></date-picker>
                    <a-button type="primary" :ghost="true" @click="filterCSList">검색</a-button>
                    <a-button @click="resetCSList">초기화</a-button>
                </a-space>
                <p/>
                <a-table :columns="columns2" size="small" :bordered="false" :data-source="completedData" :pagination="pagination" :scroll="{ x: 0, y: '57vh' }" @change="handleTableChange">
                    <span slot="tags" slot-scope="tags">
                        <a-tag v-for="tag in tags" :key="tag" class="state-btn" :class="{ red: (tag === '작성중'), green: (tag === '작성완료') }">
                            {{ tag.toUpperCase() }}
                        </a-tag>
                    </span>
                    <span slot="action" slot-scope="record">
                        <span style='cursor:pointer' @click="handlerToEdit(record.key)"><a-icon type="edit" /> Edit</span>
                    </span>
                </a-table>
            </a-card>
        </a-form>

        <!-- 일지 작성 Drawer -->
        <a-drawer 
            title="일일 작업일지 작성" 
            placement="right" 
            :closable="true" 
            :visible="flagForDrawer" 
            @close="handlerForCloseDrawer" 
            width="100%"
        >
            <a-form layout="vertical">
                <div id="print">
                    <!-- 제목/날짜 헤더 -->
                    <div class="ws-header">
                        <div class="ws-title">{{ formData.templateTexts.managerInput || '' }} 작업일보</div>
                        <div class="ws-date-row">
                            <a-input v-model="formData.basicInfo.workYear" placeholder="년" style="width:55px;" /> 년
                            <a-input v-model="formData.basicInfo.workMonth" placeholder="월" style="width:40px;margin-left:6px;" /> 월
                            <a-input v-model="formData.basicInfo.workDay" placeholder="일" style="width:40px;margin-left:6px;" /> 일
                            <a-input v-model="formData.basicInfo.workDayOfWeek" placeholder="요일" style="width:50px;margin-left:6px;" /> 요일
                        </div>
                    </div>

                    <!-- 2. 자주보전 -->
                    <div class="ws-section-title">2. 자주보전</div>
                    <div style="display:flex;gap:12px;margin-bottom:8px;">
                        <!-- 실내 온도/습도 + 설비보전 -->
                        <div style="flex:1;">
                            <div class="ws-subsection-title">실내 온도/습도</div>
                            <table class="ws-table">
                                <thead>
                                    <tr><th></th><th>오전 1</th><th>오전 2</th><th>오후 1</th><th>오후 2</th></tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="ws-label">℃</td>
                                        <td><a-input v-model="formData.tempHumidity.am1_temp" size="small" /></td>
                                        <td><a-input v-model="formData.tempHumidity.am2_temp" size="small" /></td>
                                        <td><a-input v-model="formData.tempHumidity.pm1_temp" size="small" /></td>
                                        <td><a-input v-model="formData.tempHumidity.pm2_temp" size="small" /></td>
                                    </tr>
                                    <tr>
                                        <td class="ws-label">%</td>
                                        <td><a-input v-model="formData.tempHumidity.am1_hum" size="small" /></td>
                                        <td><a-input v-model="formData.tempHumidity.am2_hum" size="small" /></td>
                                        <td><a-input v-model="formData.tempHumidity.pm1_hum" size="small" /></td>
                                        <td><a-input v-model="formData.tempHumidity.pm2_hum" size="small" /></td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="ws-subsection-title" style="margin-top:8px;">설비보전내용</div>
                            <a-textarea v-model="formData.equipmentMaintenance" :rows="3" />
                        </div>
                        <!-- 혼합기 원료 투입량 체크 -->
                        <div style="flex:1;">
                            <div class="ws-subsection-title">혼합기 원료 투입량 체크</div>
                            <table class="ws-table">
                                <thead>
                                    <tr><th>구분</th><th>활성탄 투입량</th><th>바인디 투입량</th></tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="ws-label">오전 1</td>
                                        <td><a-input v-model="formData.rawMaterial.am1_carbon" suffix="kg" size="small" /></td>
                                        <td><a-input v-model="formData.rawMaterial.am1_binder" suffix="kg" size="small" /></td>
                                    </tr>
                                    <tr>
                                        <td class="ws-label">오전 2</td>
                                        <td><a-input v-model="formData.rawMaterial.am2_carbon" suffix="kg" size="small" /></td>
                                        <td><a-input v-model="formData.rawMaterial.am2_binder" suffix="kg" size="small" /></td>
                                    </tr>
                                    <tr>
                                        <td class="ws-label">오후 1</td>
                                        <td><a-input v-model="formData.rawMaterial.pm1_carbon" suffix="kg" size="small" /></td>
                                        <td><a-input v-model="formData.rawMaterial.pm1_binder" suffix="kg" size="small" /></td>
                                    </tr>
                                    <tr>
                                        <td class="ws-label">오후 2</td>
                                        <td><a-input v-model="formData.rawMaterial.pm2_carbon" suffix="kg" size="small" /></td>
                                        <td><a-input v-model="formData.rawMaterial.pm2_binder" suffix="kg" size="small" /></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <!-- 3. 성능평가 -->
                    <div class="ws-section-title">3. 성능평가</div>
                    <div style="margin-bottom:6px;">
                        <span class="ws-label" style="margin-right:8px;">길이 평가 모델:</span>
                        <a-input v-model="formData.length.model" style="width:180px;" size="small" />
                    </div>
                    <table class="ws-table ws-perf-table">
                        <thead>
                            <tr>
                                <th rowspan="2"></th>
                                <th colspan="3">강도 평가</th>
                                <th colspan="3">중량 평가</th>
                                <th colspan="4">길이 평가</th>
                            </tr>
                            <tr>
                                <th>1호기</th><th>2호기</th><th>3호기</th>
                                <th>1호기</th><th>2호기</th><th>3호기</th>
                                <th>1호기</th><th>2호기</th><th>3호기</th><th>특이사항</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="slot in timeSlots" :key="slot.key">
                                <td class="ws-label">{{ slot.label }}</td>
                                <td><a-input v-model="formData.strength[slot.key + '_m1']" size="small" /></td>
                                <td><a-input v-model="formData.strength[slot.key + '_m2']" size="small" /></td>
                                <td><a-input v-model="formData.strength[slot.key + '_m3']" size="small" /></td>
                                <td><a-input v-model="formData.weight[slot.key + '_m1']" size="small" suffix="g" /></td>
                                <td><a-input v-model="formData.weight[slot.key + '_m2']" size="small" suffix="g" /></td>
                                <td><a-input v-model="formData.weight[slot.key + '_m3']" size="small" suffix="g" /></td>
                                <td><a-input v-model="formData.length[slot.key + '_m1']" size="small" /></td>
                                <td><a-input v-model="formData.length[slot.key + '_m2']" size="small" /></td>
                                <td><a-input v-model="formData.length[slot.key + '_m3']" size="small" /></td>
                                <td><a-input v-model="formData.length[slot.key + '_special']" size="small" /></td>
                            </tr>
                        </tbody>
                    </table>

                    <!-- 4. 탁도/잔류염소 평가 -->
                    <div class="ws-section-title">4. 성능평가 (탁도/잔류염소 평가)</div>
                    <div style="display:flex;gap:12px;">
                        <!-- 오전 -->
                        <div style="flex:1;">
                            <div class="ws-subsection-title">오전</div>
                            <div class="ws-note-text">{{ formData.templateTexts.turbidityNote }}</div>
                            <table class="ws-table">
                                <thead>
                                    <tr>
                                        <th>모델</th><th>평가자</th>
                                        <th>#1탁도</th><th>#1유량</th>
                                        <th>#2탁도</th><th>#2유량</th>
                                        <th>#3탁도</th><th>#3유량</th>
                                        <th>특이사항</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td><a-input v-model="formData.turbidityAm.model" size="small" /></td>
                                        <td><a-input v-model="formData.turbidityAm.evaluator" size="small" /></td>
                                        <td><a-input v-model="formData.turbidityAm.m1_turbidity" size="small" /></td>
                                        <td><a-input v-model="formData.turbidityAm.m1_flow" size="small" /></td>
                                        <td><a-input v-model="formData.turbidityAm.m2_turbidity" size="small" /></td>
                                        <td><a-input v-model="formData.turbidityAm.m2_flow" size="small" /></td>
                                        <td><a-input v-model="formData.turbidityAm.m3_turbidity" size="small" /></td>
                                        <td><a-input v-model="formData.turbidityAm.m3_flow" size="small" /></td>
                                        <td><a-input v-model="formData.turbidityAm.specialNote" size="small" /></td>
                                    </tr>
                                    <tr>
                                        <td class="ws-label" colspan="2">원수탁도 / 시간</td>
                                        <td><a-input v-model="formData.turbidityAm.sourceWaterTurbidity" size="small" /></td>
                                        <td><a-input v-model="formData.turbidityAm.time" size="small" placeholder="시간" /></td>
                                        <td colspan="5"></td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="ws-note-text" style="margin-top:8px;">{{ formData.templateTexts.concentrationFormula }}</div>
                            <table class="ws-table" style="margin-top:4px;">
                                <thead>
                                    <tr>
                                        <th>시작투입량(ml)</th><th>평가자</th>
                                        <th>중량</th><th>중량</th><th>중량</th>
                                        <th rowspan="3">특이사항</th>
                                    </tr>
                                    <tr>
                                        <th>원수공급량(1t)</th><th>용해농도</th>
                                        <th>#1농도(g)</th><th>#2농도(g)</th><th>#3농도(g)</th>
                                    </tr>
                                    <tr>
                                        <th></th><th></th>
                                        <th>#1제거율(%)</th><th>#2제거율(%)</th><th>#3제거율(%)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td><a-input v-model="formData.chlorineAm.startInput_ml" size="small" /></td>
                                        <td><a-input v-model="formData.chlorineAm.evaluator" size="small" placeholder="평가자" /></td>
                                        <td><a-input v-model="formData.chlorineAm.m1_weight" size="small" /></td>
                                        <td><a-input v-model="formData.chlorineAm.m2_weight" size="small" /></td>
                                        <td><a-input v-model="formData.chlorineAm.m3_weight" size="small" /></td>
                                        <td rowspan="3" style="padding:2px;vertical-align:top;">
                                            <a-textarea v-model="formData.chlorineAm.specialNote" :auto-size="false" style="width:100%;height:100%;min-height:80px;resize:none;" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><a-input v-model="formData.chlorineAm.sourceSupply_1t" size="small" /></td>
                                        <td><a-input v-model="formData.chlorineAm.dissolvedConc" size="small" placeholder="용해농도" /></td>
                                        <td><a-input v-model="formData.chlorineAm.m1_conc" size="small" /></td>
                                        <td><a-input v-model="formData.chlorineAm.m2_conc" size="small" /></td>
                                        <td><a-input v-model="formData.chlorineAm.m3_conc" size="small" /></td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td><a-input v-model="formData.chlorineAm.m1_rate" size="small" /></td>
                                        <td><a-input v-model="formData.chlorineAm.m2_rate" size="small" /></td>
                                        <td><a-input v-model="formData.chlorineAm.m3_rate" size="small" /></td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="ws-note-text">{{ formData.templateTexts.chlorineNote }}</div>
                        </div>

                        <!-- 오후 -->
                        <div style="flex:1;">
                            <div class="ws-subsection-title">오후</div>
                            <div class="ws-note-text">{{ formData.templateTexts.turbidityNote }}</div>
                            <table class="ws-table">
                                <thead>
                                    <tr>
                                        <th>모델</th><th>평가자</th>
                                        <th>#1탁도</th><th>#1유량</th>
                                        <th>#2탁도</th><th>#2유량</th>
                                        <th>#3탁도</th><th>#3유량</th>
                                        <th>특이사항</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td><a-input v-model="formData.turbidityPm.model" size="small" /></td>
                                        <td><a-input v-model="formData.turbidityPm.evaluator" size="small" /></td>
                                        <td><a-input v-model="formData.turbidityPm.m1_turbidity" size="small" /></td>
                                        <td><a-input v-model="formData.turbidityPm.m1_flow" size="small" /></td>
                                        <td><a-input v-model="formData.turbidityPm.m2_turbidity" size="small" /></td>
                                        <td><a-input v-model="formData.turbidityPm.m2_flow" size="small" /></td>
                                        <td><a-input v-model="formData.turbidityPm.m3_turbidity" size="small" /></td>
                                        <td><a-input v-model="formData.turbidityPm.m3_flow" size="small" /></td>
                                        <td><a-input v-model="formData.turbidityPm.specialNote" size="small" /></td>
                                    </tr>
                                    <tr>
                                        <td class="ws-label" colspan="2">원수탁도 / 시간</td>
                                        <td><a-input v-model="formData.turbidityPm.sourceWaterTurbidity" size="small" /></td>
                                        <td><a-input v-model="formData.turbidityPm.time" size="small" placeholder="시간" /></td>
                                        <td colspan="5"></td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="ws-note-text" style="margin-top:8px;">{{ formData.templateTexts.concentrationFormula }}</div>
                            <table class="ws-table" style="margin-top:4px;">
                                <thead>
                                    <tr>
                                        <th>시작투입량(ml)</th><th>평가자</th>
                                        <th>중량</th><th>중량</th><th>중량</th>
                                        <th rowspan="3">특이사항</th>
                                    </tr>
                                    <tr>
                                        <th>원수공급량(1t)</th><th>용해농도</th>
                                        <th>#1농도(g)</th><th>#2농도(g)</th><th>#3농도(g)</th>
                                    </tr>
                                    <tr>
                                        <th></th><th></th>
                                        <th>#1제거율(%)</th><th>#2제거율(%)</th><th>#3제거율(%)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td><a-input v-model="formData.chlorinePm.startInput_ml" size="small" /></td>
                                        <td><a-input v-model="formData.chlorinePm.evaluator" size="small" placeholder="평가자" /></td>
                                        <td><a-input v-model="formData.chlorinePm.m1_weight" size="small" /></td>
                                        <td><a-input v-model="formData.chlorinePm.m2_weight" size="small" /></td>
                                        <td><a-input v-model="formData.chlorinePm.m3_weight" size="small" /></td>
                                        <td rowspan="3" style="padding:2px;vertical-align:top;">
                                            <a-textarea v-model="formData.chlorinePm.specialNote" :auto-size="false" style="width:100%;height:100%;min-height:80px;resize:none;" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><a-input v-model="formData.chlorinePm.sourceSupply_1t" size="small" /></td>
                                        <td><a-input v-model="formData.chlorinePm.dissolvedConc" size="small" placeholder="용해농도" /></td>
                                        <td><a-input v-model="formData.chlorinePm.m1_conc" size="small" /></td>
                                        <td><a-input v-model="formData.chlorinePm.m2_conc" size="small" /></td>
                                        <td><a-input v-model="formData.chlorinePm.m3_conc" size="small" /></td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td><a-input v-model="formData.chlorinePm.m1_rate" size="small" /></td>
                                        <td><a-input v-model="formData.chlorinePm.m2_rate" size="small" /></td>
                                        <td><a-input v-model="formData.chlorinePm.m3_rate" size="small" /></td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="ws-note-text">{{ formData.templateTexts.chlorineNote }}</div>
                        </div>
                    </div>

                    <!-- 하단 -->
                    <table class="ws-table" style="margin-top:16px;width:100%;">
                        <tbody>
                            <tr>
                                <td class="ws-label" style="width:100px;">유실 내용</td>
                                <td style="width:45%;"><a-textarea v-model="formData.wasteContent" :rows="2" /></td>
                                <td class="ws-label" style="width:90px;">평가 등당</td>
                                <td><a-input v-model="formData.evalGrade" suffix="g" size="small" /></td>
                                <td class="ws-label" style="width:90px;">작업 등당</td>
                                <td><a-input v-model="formData.workGrade" suffix="kg" size="small" /></td>
                            </tr>
                        </tbody>
                    </table>
                </div><!-- /#print -->

                <a-divider />
                <div style="text-align:center;margin-top:16px;">
                    <a-button @click="handlerForCloseDrawer" style="margin-right:8px;">취소</a-button>
                    <a-button type="default" @click="handleSaveTemp" style="margin-right:8px;">임시저장</a-button>
                    <a-button type="primary" @click="handleSaveComplete">작성완료</a-button>
                </div>
            </a-form>
        </a-drawer>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import PageHeader from "../components/PageHeader.vue";

const columns = [
    { title: '상태', dataIndex: 'tags', key: 'tags', scopedSlots: { customRender: 'tags' }, width: 100 },
    { title: '라인명', dataIndex: 'lineName', key: 'lineName' },
    { title: '생산모델', dataIndex: 'productModel', key: 'productModel' },
    { title: '작성자', dataIndex: 'writer', key: 'writer' },
    { title: '최종수정일', dataIndex: 'updated', key: 'updated' },
    { title: '관리', key: 'action', scopedSlots: { customRender: 'action' }, width: 200 },
];

const columns2 = [
    { title: '상태', dataIndex: 'tags', key: 'tags', scopedSlots: { customRender: 'tags' }, width: 100 },
    { title: '라인명', dataIndex: 'lineName', key: 'lineName' },
    { title: '생산모델', dataIndex: 'productModel', key: 'productModel' },
    { title: '작성자', dataIndex: 'writer', key: 'writer' },
    { title: '작성일자', dataIndex: 'date', key: 'date' },
    { title: '최종수정일', dataIndex: 'updated', key: 'updated' },
    { title: '관리', key: 'action', scopedSlots: { customRender: 'action' }, width: 150 },
];

function makeDefaultFormData() {
    return {
        templateTexts: {
            managerInput: '',
            turbidityNote: '10NTU 이하 유량:15~22',
            concentrationFormula: '(원수농도-측정농도)/원수 농도*100',
            chlorineNote: '염소 제거율 : 85% 이상'
        },
        basicInfo: {
            workYear: '', workMonth: '', workDay: '', workDayOfWeek: '',
            lineName: '', writer: '', productModel: '', dateTime: ''
        },
        tempHumidity: { am1_temp: '', am2_temp: '', pm1_temp: '', pm2_temp: '', am1_hum: '', am2_hum: '', pm1_hum: '', pm2_hum: '' },
        rawMaterial: { am1_carbon: '', am1_binder: '', am2_carbon: '', am2_binder: '', pm1_carbon: '', pm1_binder: '', pm2_carbon: '', pm2_binder: '' },
        equipmentMaintenance: '',
        strength: { am1_m1:'', am1_m2:'', am1_m3:'', am2_m1:'', am2_m2:'', am2_m3:'', pm1_m1:'', pm1_m2:'', pm1_m3:'', pm2_m1:'', pm2_m2:'', pm2_m3:'' },
        weight:   { am1_m1:'', am1_m2:'', am1_m3:'', am2_m1:'', am2_m2:'', am2_m3:'', pm1_m1:'', pm1_m2:'', pm1_m3:'', pm2_m1:'', pm2_m2:'', pm2_m3:'' },
        length:   { model:'', am1_m1:'', am1_m2:'', am1_m3:'', am1_special:'', am2_m1:'', am2_m2:'', am2_m3:'', am2_special:'', pm1_m1:'', pm1_m2:'', pm1_m3:'', pm1_special:'', pm2_m1:'', pm2_m2:'', pm2_m3:'', pm2_special:'' },
        turbidityAm: { model:'', evaluator:'', specialNote:'', time:'', sourceWaterTurbidity:'', m1_turbidity:'', m1_flow:'', m2_turbidity:'', m2_flow:'', m3_turbidity:'', m3_flow:'' },
        chlorineAm:  { evaluator:'', specialNote:'', startInput_ml:'', sourceSupply_1t:'', dissolvedConc:'', m1_weight:'', m2_weight:'', m3_weight:'', m1_conc:'', m2_conc:'', m3_conc:'', m1_rate:'', m2_rate:'', m3_rate:'' },
        turbidityPm: { model:'', evaluator:'', specialNote:'', time:'', sourceWaterTurbidity:'', m1_turbidity:'', m1_flow:'', m2_turbidity:'', m2_flow:'', m3_turbidity:'', m3_flow:'' },
        chlorinePm:  { evaluator:'', specialNote:'', startInput_ml:'', sourceSupply_1t:'', dissolvedConc:'', m1_weight:'', m2_weight:'', m3_weight:'', m1_conc:'', m2_conc:'', m3_conc:'', m1_rate:'', m2_rate:'', m3_rate:'' },
        wasteContent: '', evalGrade: '', workGrade: ''
    };
}

export default {
    name: 'FilterWorkSheet',
    components: {
        PageHeader,
        DatePicker,
    },
    data() {
        return {
            columns,
            columns2,
            workingData: [],
            currentEditKey: null,
            completedData: [],
            workingCount: 0,
            completedCount: 0,
            templateList: [],
            selectedTemplate: null,
            filterCS: '',
            filterField: '라인명',
            filterDateStartCS: '',
            filterDateEndCS: '',
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0,
                showSizeChanger: true,
                showTotal: (total, range) => `${range[0]}-${range[1]} / ${total}개`
            },
            flagForDrawer: false,
            formData: makeDefaultFormData()
        };
    },
    computed: {
        timeSlots() {
            return [
                { key: 'am1', label: '오전 1' },
                { key: 'am2', label: '오전 2' },
                { key: 'pm1', label: '오후 1' },
                { key: 'pm2', label: '오후 2' }
            ];
        }
    },
    mounted() {
        this.fetchTemplateList();
        this.fetchWorkSheetList();
    },
    methods: {
        fetchTemplateList() {
            this.$http.get(`${this.$store.state.nodeApiUrl}/filter/work/template/list?size=100&page=0&state=FW_B`)
                .then((response) => {
                    if (response.status === 200 && response.data.code === 'success') {
                        this.templateList = response.data.data.content.map(item => ({ id: item.productCsSeq, name: item.name }));
                    }
                }).catch((error) => console.error(error));
        },
        fetchWorkSheetList() {
            const page = this.pagination.current - 1;
            const size = this.pagination.pageSize;
            
            this.$http.get(`${this.$store.state.nodeApiUrl}/filter/work/worksheet/list?size=100&page=0&state=FW_C`)
                .then((response) => {
                    if (response.status === 200 && response.data.code === 'success') {
                        this.workingData = response.data.data.content.map(item => ({
                            key: item.productCsSeq, tags: ['작성중'], lineName: item.line,
                            productModel: item.productModel || '-', writer: item.manager, updated: item.updated
                        }));
                        this.workingCount = this.workingData.length;
                    }
                }).catch((error) => console.error(error));
            
            this.$http.get(`${this.$store.state.nodeApiUrl}/filter/work/worksheet/list?size=${size}&page=${page}&state=FW_D`)
                .then((response) => {
                    if (response.status === 200 && response.data.code === 'success') {
                        this.pagination.total = response.data.data.totalElements || 0;
                        this.completedData = response.data.data.content.map(item => ({
                            key: item.productCsSeq, tags: ['작성완료'], lineName: item.line,
                            productModel: item.productModel || '-', writer: item.manager,
                            date: item.updated ? item.updated.split(' ')[0] : '', updated: item.updated
                        }));
                        this.completedCount = response.data.data.totalElements;
                    }
                }).catch((error) => console.error(error));
        },
        loadTemplate() {
            if (!this.selectedTemplate) {
                this.$message.error('템플릿을 선택해주세요');
                return;
            }
            
            this.$http.post(`${this.$store.state.nodeApiUrl}/filter/work/worksheet/copy/${this.selectedTemplate}`, {
                lineName: '', writer: sessionStorage.getItem('user_name') || '',
                creator: sessionStorage.getItem('user_name') || 'system', updater: sessionStorage.getItem('user_name') || 'system'
            }).then((response) => {
                if (response.status === 200 && response.data.code === 'success') {
                    this.$message.success('템플릿을 불러왔습니다.');
                    this.selectedTemplate = null;
                    this.fetchWorkSheetList();
                    const newSeq = response.data.data && response.data.data.productCsSeq;
                    if (newSeq) this.handlerToEdit(newSeq);
                } else {
                    this.$message.error('템플릿 불러오기에 실패했습니다: ' + (response.data.message || '알 수 없는 오류'));
                }
            }).catch((error) => { console.error(error); this.$message.error('템플릿 불러오기에 실패했습니다.'); });
        },
        filterCSList() {
            console.log('Filter:', this.filterField, this.filterCS);
        },
        resetCSList() {
            this.filterCS = '';
            this.filterDateStartCS = '';
            this.filterDateEndCS = '';
            this.fetchWorkSheetList();
        },
        handleTableChange(pagination) {
            this.pagination.current = pagination.current;
            this.pagination.pageSize = pagination.pageSize;
            this.fetchWorkSheetList();
        },
        handlerToEdit(key) {
            this.currentEditKey = key;
            this.$http.get(`${this.$store.state.nodeApiUrl}/filter/work/template/item/${key}`)
                .then((response) => {
                    if (response.status === 200 && response.data.code === 'success') {
                        const data = response.data.data;
                        const fd = makeDefaultFormData();

                        // 템플릿 텍스트 로드
                        const tt = data.templateTexts || {};
                        fd.templateTexts.managerInput = tt.managerInput || '';
                        fd.templateTexts.turbidityNote = tt.turbidityNote || '10NTU 이하 유량:15~22';
                        fd.templateTexts.concentrationFormula = tt.concentrationFormula || '(원수농도-측정농도)/원수 농도*100';
                        fd.templateTexts.chlorineNote = tt.chlorineNote || '염소 제거율 : 85% 이상';

                        // 기본정보 로드
                        fd.basicInfo.lineName = data.lineName || '';
                        fd.basicInfo.writer = data.writer || '';
                        fd.basicInfo.productModel = data.productModel || '';
                        fd.basicInfo.dateTime = data.created || '';

                        // 저장된 일지 데이터 복원
                        const wd = data.worksheetData || {};
                        if (wd.basicInfo) {
                            fd.basicInfo.workYear = wd.basicInfo.workYear || '';
                            fd.basicInfo.workMonth = wd.basicInfo.workMonth || '';
                            fd.basicInfo.workDay = wd.basicInfo.workDay || '';
                            fd.basicInfo.workDayOfWeek = wd.basicInfo.workDayOfWeek || '';
                        }
                        if (wd.tempHumidity) fd.tempHumidity = { ...fd.tempHumidity, ...wd.tempHumidity };
                        if (wd.rawMaterial) fd.rawMaterial = { ...fd.rawMaterial, ...wd.rawMaterial };
                        if (wd.equipmentMaintenance !== undefined) fd.equipmentMaintenance = wd.equipmentMaintenance;
                        if (wd.strength) fd.strength = { ...fd.strength, ...wd.strength };
                        if (wd.weight) fd.weight = { ...fd.weight, ...wd.weight };
                        if (wd.length) fd.length = { ...fd.length, ...wd.length };
                        if (wd.turbidityAm) fd.turbidityAm = { ...fd.turbidityAm, ...wd.turbidityAm };
                        if (wd.chlorineAm) fd.chlorineAm = { ...fd.chlorineAm, ...wd.chlorineAm };
                        if (wd.turbidityPm) fd.turbidityPm = { ...fd.turbidityPm, ...wd.turbidityPm };
                        if (wd.chlorinePm) fd.chlorinePm = { ...fd.chlorinePm, ...wd.chlorinePm };
                        if (wd.wasteContent !== undefined) fd.wasteContent = wd.wasteContent;
                        if (wd.evalGrade !== undefined) fd.evalGrade = wd.evalGrade;
                        if (wd.workGrade !== undefined) fd.workGrade = wd.workGrade;

                        this.formData = fd;
                        this.flagForDrawer = true;
                    }
                }).catch((error) => { console.error(error); this.$message.error('데이터 조회에 실패했습니다.'); });
        },
        handlerToDelete(key) {
            this.$confirm({
                title: '삭제 확인',
                content: '정말 삭제하시겠습니까?',
                onOk: () => {
                    this.$http.delete(`${this.$store.state.nodeApiUrl}/filter/delete/${key}`)
                        .then((response) => {
                            if (response.status === 200 && response.data.code === 'success') {
                                this.$message.success('삭제되었습니다.');
                                this.fetchWorkSheetList();
                            }
                        }).catch((error) => { console.error(error); this.$message.error('삭제에 실패했습니다.'); });
                }
            });
        },
        handlerForCloseDrawer() {
            this.flagForDrawer = false;
            this.currentEditKey = null;
            this.formData = makeDefaultFormData();
        },
        handleSaveTemp() {
            this.saveWorkSheet('FW_C');
        },
        handleSaveComplete() {
            this.saveWorkSheet('FW_D');
        },
        saveWorkSheet(state) {
            if (!this.currentEditKey) {
                this.$message.error('저장할 항목을 선택해주세요.');
                return;
            }

            const fd = this.formData;
            const workDate = fd.basicInfo.workYear && fd.basicInfo.workMonth && fd.basicInfo.workDay
                ? `${fd.basicInfo.workYear}-${String(fd.basicInfo.workMonth).padStart(2,'0')}-${String(fd.basicInfo.workDay).padStart(2,'0')}`
                : null;

            const postData = {
                state: state,
                updater: sessionStorage.getItem('user_name') || 'system',
                lineName: fd.basicInfo.lineName,
                writer: fd.basicInfo.writer,
                productModel: fd.basicInfo.productModel,
                workDate: workDate,
                worksheetData: {
                    basicInfo: fd.basicInfo,
                    tempHumidity: fd.tempHumidity,
                    rawMaterial: fd.rawMaterial,
                    equipmentMaintenance: fd.equipmentMaintenance,
                    strength: fd.strength,
                    weight: fd.weight,
                    length: fd.length,
                    turbidityAm: fd.turbidityAm,
                    chlorineAm: fd.chlorineAm,
                    turbidityPm: fd.turbidityPm,
                    chlorinePm: fd.chlorinePm,
                    wasteContent: fd.wasteContent,
                    evalGrade: fd.evalGrade,
                    workGrade: fd.workGrade
                }
            };

            this.$http.post(`${this.$store.state.nodeApiUrl}/filter/work/data/save/${this.currentEditKey}`, postData)
                .then((response) => {
                    if (response.status === 200 && response.data.code === 'success') {
                        this.$message.success(state === 'FW_C' ? '임시저장되었습니다.' : '작성완료되었습니다.');
                        this.handlerForCloseDrawer();
                        this.fetchWorkSheetList();
                    }
                }).catch((error) => { console.error(error); this.$message.error('저장에 실패했습니다.'); });
        }
    }
};
</script>

<style scoped>
.state-btn {
    font-weight: bold;
    padding: 2px 8px;
}
.state-btn.red { background-color: #ff4d4f; color: white; }
.state-btn.green { background-color: #52c41a; color: white; }
.div_action { text-align: right; }

/* 작업일지 양식 */
.ws-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
    padding: 8px 0;
    border-bottom: 2px solid #333;
}
.ws-title {
    font-size: 18px;
    font-weight: bold;
    color: #c0392b;
}
.ws-date-row {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 13px;
}
.ws-section-title {
    font-size: 14px;
    font-weight: bold;
    background: #e8f4fd;
    padding: 4px 8px;
    margin: 12px 0 6px 0;
    border-left: 4px solid #2980b9;
}
.ws-subsection-title {
    font-size: 12px;
    font-weight: bold;
    color: #555;
    margin-bottom: 4px;
}
.ws-note-text {
    font-size: 12px;
    color: #c0392b;
    font-weight: bold;
    padding: 2px 0;
}
.ws-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 12px;
    margin-bottom: 4px;
}
.ws-table th, .ws-table td {
    border: 1px solid #bbb;
    padding: 3px 5px;
    text-align: center;
    vertical-align: middle;
}
.ws-table th {
    background: #f0f4f8;
    font-weight: bold;
    font-size: 11px;
}
.ws-table td.ws-label {
    background: #fafafa;
    font-weight: bold;
    font-size: 11px;
    white-space: nowrap;
}
.ws-perf-table th, .ws-perf-table td {
    min-width: 60px;
}
</style>
